<template>
  <div>
    <v-stage ref="stage" :config="stageSize" @mousedown="handleStageMouseDown">
      <v-layer ref="layer"> </v-layer>
    </v-stage>
  </div>
</template>

<script>
// import ProfileGroupFactory from './ProfileGroupFactory'
const width = 1200; //window.innerWidth;
const height = window.innerHeight - 300;

export default {
  name: "ProfileGroup",
  // components: { "profileGroupFactory": ProfileGroupFactory },
  data() {
    return {
      selectedGroup: "",
      // layer = this$refs.layer
      stageSize: {
        width: width,
        height: height
      },
      msg: "test",
      layer1: ""
    };
  },
  mounted() {
    var groups = this.approvedItems;
    console.log(typeof ("GROUP TYPE ", groups));

    var colors = ["red", "orange", "yellow"];

    var layer = new Konva.Layer();
    this.layer1 = layer;

    var tooltipLayer = new Konva.Layer();

    var textDisplay = new Konva.Text({
      x: 25,
      y: 5,
      name: "text2show",
      id: "text2show"
    });
    layer.add(textDisplay);

    this.drawSprint(layer);

    let count = 0;
    let y_off = 10;
    let grpNum = 0;

    groups.forEach(grp => {
      let name = grp.name;
      let profile = grp.profile.value;

      if (count === 5) {
        count = 0;
        y_off = 210;
      }

      this.makeProfileGroup(
        layer,
        name,
        profile,
        count,
        y_off,
        this.$store,
        grpNum,
        tooltipLayer
      );

      count++;
      grpNum++;
    });

    this.$refs.stage.getStage().add(layer);
    this.$refs.stage.getStage().add(tooltipLayer);
  },
  methods: {
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        e.target.find("Transformer").detach();
        e.target.draw();
        return;
      }
    },
    makeProfileGroup(
      layer,
      name,
      profile,
      count,
      y_off,
      _store,
      grpNum,
      tooltipLayer
    ) {
      console.log("COUNT ", count);

      var tooltip = new Konva.Text({
        text: "",
        fontFamily: "Calibri",
        fontSize: 18,
        padding: 5,
        textFill: "red",
        fill: "black",
        alpha: 0.75,
        visible: false
      });
      tooltipLayer.add(tooltip);

      // initialise
      let scanX = 0;
      let scanY = 0;
      let analyseX = 0;
      let analyseY = 0;
      let leanX = 0;
      let leanY = 0;
      let valueX = 0;
      let valueY = 0;
      let endX = 0;
      let endY = 0;

      switch (profile) {
        case 1:
          scanX = 10;
          scanY = 100;
          analyseX = 10;
          analyseY = 10;
          leanX = 10;
          leanY = 10;
          valueX = 50;
          valueY = 10;
          endX = 50;
          endY = 100;
          break;
        case 2:
          scanX = 10;
          scanY = 100;
          analyseX = 10;
          analyseY = 10;
          leanX = 10;
          leanY = 10;
          valueX = 20;
          valueY = 10;
          endX = 150;
          endY = 100;
          break;
        case 3:
          // console.log("Profile Factory ", grp);
          scanX = 10;
          scanY = 100;
          analyseX = 40;
          analyseY = 10;
          leanX = 60;
          leanY = 50;
          valueX = 100;
          valueY = 100;
          endX = 150;
          endY = 100;
          break;
        case 4:
          scanX = 10;
          scanY = 100;
          analyseX = 20;
          analyseY = 10;
          leanX = 50;
          leanY = 20;
          valueX = 80;
          valueY = 20;
          endX = 150;
          endY = 100;
          break;
      }
      // check the state to see if there are x and y already set
      console.log(this.approvedItems);
      // Grab x and y from previous pass and use
      let _approvedItem = this.approvedItems[grpNum];

      let _x = 210 + 200 * count;
      if (_approvedItem.layout.x != -1) {
        _x = _approvedItem.layout.x;
        console.log("I am XXX", _x);
      }

      let _y = y_off;
      if (_approvedItem.layout.y != -1) {
        _y = _approvedItem.layout.y;
      }

      let _scaleX = 1.0;
      let _width = 160;
      if (_approvedItem.layout.scaleX != -100) {
        _scaleX = _approvedItem.layout.scaleX;
        _width = parseInt(_width * _scaleX);
        console.log(
          "I am width and scale XXX",
          _width,
          _scaleX,
          _approvedItem.layout.scaleX
        );
      }

      let _scaleY = 1.0;
      let _height = 120;
      if (_approvedItem.layout.scaleY != -100) {
        _scaleY = _approvedItem.layout.scaleY;
        _height = parseInt(_height * _scaleY);
      }

      var group = new Konva.Group({
        name: name,
        draggable: true,
        x: _x, //210 + 200 * count,
        y: _y, //y_off, //+ (100 * count)
        scaleX: _scaleX,
        scaleY: _scaleY,
        width: _width, //150,
        height: _height //100
        // rotation: 20
      });

      var rect = new Konva.Rect({
        name: "rect1",
        fill: "white",
        x: 5,
        y: 5,
        width: 160,
        height: 120
        // fill: 'white',
        // draggable: true
      });
      group.add(rect);

      var line1 = new Konva.Line({
        stroke: "red",
        strokeWidth: 5,
        points: [scanX, scanY, analyseX, analyseY]
      });
      group.add(line1);

      var line2 = new Konva.Line({
        stroke: "orange",
        strokeWidth: 5,
        points: [analyseX, analyseY, leanX, leanY]
      });
      group.add(line2);

      var line3 = new Konva.Line({
        stroke: "green",
        strokeWidth: 5,
        points: [leanX, leanY, valueX, leanY]
      });
      group.add(line3);

      var line4 = new Konva.Line({
        stroke: "blue",
        strokeWidth: 5,
        points: [valueX, leanY, endX, endY]
      });
      group.add(line4);

      group.on("mouseover", function() {
        document.body.style.cursor = "pointer";
        console.log(this.$refs, group.name());
        var mousePos = layer.getStage().getPointerPosition();
        tooltip.position({
          x: mousePos.x + 5,
          y: mousePos.y + 5
        });
        tooltip.text(group.name());
        tooltip.show();
        tooltipLayer.add(tooltip);
        tooltipLayer.batchDraw();
      }),
        group.on("mouseout", function() {
          document.body.style.cursor = "default";

          tooltip.hide();
          tooltipLayer.draw();
          console.log(group);

          // Remove transformer from group
        });

      var txt = new Konva.Text({
        x: 5,
        y: 8,
        text: name,
        width: 150,
        padding: 15,
        align: "center"
      });

      group.add(txt);

      layer.add(group);

      // var tr = new Konva.Transformer();
      // layer.add(tr);
      // tr.attachTo(group);
      // layer.draw();

      group.on("transformstart", function() {
        console.log("transform start");
      });

      group.on("dragmove", function() {
        // updateText();
        var lines = [
          "ID: " + group.name(),
          "x: " + group.x().toFixed(2),
          "y: " + group.y().toFixed(2),
          "rotation: " + group.rotation().toFixed(2),
          "width: " + group.width().toFixed(2),
          "height: " + group.height().toFixed(2),
          "scaleX: " + group.scaleX().toFixed(2),
          "scaleY: " + group.scaleY().toFixed(2)
        ];
        // layer.find("#text2show").text(lines.join("\n"));
        layer.batchDraw();
        console.log("STORE ", _store);
        let payload = {
          name: group.name(),
          x: group.x(),
          y: group.y(),
          scaleX: group.scaleX(),
          scaleY: group.scaleY(),
          complexity: _complexity,
          duration: _duration
        };
        _store.dispatch("move", payload);
      });
      group.on("transform", function() {
        let _complexity = 0;
        let _complexityRaw = 120 * group.scaleY();
        if (_complexityRaw >= 103) {
          _complexity = 20;
        } else if (_complexityRaw >= 85 && _complexityRaw < 103) {
          _complexity = 13;
        } else if (_complexityRaw >= 68 && _complexityRaw < 85) {
          _complexity = 8;
        } else if (_complexityRaw >= 51 && _complexityRaw < 68) {
          _complexity = 5;
        } else if (_complexityRaw >= 34 && _complexityRaw < 51) {
          _complexity = 3;
        } else if (_complexityRaw >= 17 && _complexityRaw < 34) {
          _complexity = 2;
        } else if (_complexityRaw >= 0 && _complexityRaw < 17) {
          _complexity = 1;
        }

        let _duration = ((160 * group.scaleX()) / 20).toFixed(2);

        var lines = [
          "ID: " + group.name(),
          "Complexity: " + _complexity,
          "Duration: " + _duration,
          "",
          "x: " + group.x().toFixed(2),
          "y: " + group.y().toFixed(2),
          "rotation: " + group.rotation().toFixed(2),
          "width: " + group.width().toFixed(2),
          "height: " + group.height().toFixed(2),
          "scaleX: " + group.scaleX().toFixed(2),
          "scaleY: " + group.scaleY().toFixed(2)
        ];
        // layer.find("#text2show").text(lines.join("\n"));
        layer.batchDraw();

        // store to Vuex
        let payload = {
          name: group.name(),
          x: group.x(),
          y: group.y(),
          scaleX: group.scaleX(),
          scaleY: group.scaleY(),
          complexity: _complexity,
          duration: _duration
        };
        _store.dispatch("move", payload);
      });

      group.on("transformend", function() {
        console.log("transform end");
      });

      group.on("mousedown", function() {
        // Check for transformer
        group
          .getLayer()
          .find("Transformer")
          .detach();
        // Add new if needed
        var tr = new Konva.Transformer();
        layer.add(tr);
        tr.attachTo(group);
        layer.draw();
      });

      // layer.getStage().add(tooltipLayer)
      // tooltipLayer.batchDraw()
    },
    drawSprint(layer) {
      let dayWidth = parseInt((width - 14) / 6);
      console.log("DAYWIDTH", dayWidth);

      for (let i = 0; i < 14; i++) {
        let dayStart = new Konva.Line({
          points: [i * dayWidth, 0, i * dayWidth, height - 140],
          stroke: "grey",
          strokeWidth: 3,
          lineCap: "round",
          lineJoin: "round"
        });
        layer.add(dayStart);
      }

      let labels = ["20", "13", " 8", " 5", " 3", " 2", " 1"];
      let scaleSep = 20;
      for (let j = 0; j < 8; j++) {
        // draw a scale 1, 2, 3, 5, 8, 13, 20 across the screen
        let scaleLine = new Konva.Line({
          points: [dayWidth, scaleSep * j, width - 14, scaleSep * j],
          stroke: "grey",
          strokeWidth: 3,
          lineCap: "round",
          lineJoin: "round"
        });
        let label = new Konva.Text({
          text: labels[j],
          x: dayWidth - 20,
          y: scaleSep * j + 4,
          strike: "blue"
        });

        layer.add(scaleLine);
        layer.add(label);
      }

      // Repeat for second week
      for (let j = 0; j < 8; j++) {
        // draw a scale 1, 2, 3, 5, 8, 13, 20 across the screen
        let scaleLine = new Konva.Line({
          points: [
            dayWidth,
            200 + scaleSep * j,
            width - 14,
            200 + scaleSep * j
          ],
          stroke: "grey",
          strokeWidth: 3,
          lineCap: "round",
          lineJoin: "round"
        });
        let label = new Konva.Text({
          text: labels[j],
          x: dayWidth - 20,
          y: scaleSep * (j + 4) + 120,
          strike: "blue"
        });

        layer.add(scaleLine);
        layer.add(label);
      }
    }
  },

  computed: {
    drawGroup() {
      // var groups = this.getGroups();

      var groups = this.approvedItems.data;

      groups.forEach(group => {
        stroke;
        moveTo(scanX, scanY);
        lineTo(analyseX, analyseY);
      });
    },
    approvedItems() {
      console.log("STORE CALL ", this.$store);
      return this.$store.getters.approvedItems;
    }
  }
};
</script>

<style>
.controls {
  margin-bottom: 30px;
}
</style>
